import classNames from 'classnames';
import {
  ColorProps,
  getColorClass
} from '../../../constants/typography';
import Image, {
  Props as ImageProps
} from '../../Atoms/Image';
import Text from '../../Atoms/Text';
import Title from '../../Atoms/Title';
import SocialBar, { SocialItemProps } from '../SocialBar';

interface Props {
  img: ImageProps;
  title: string;
  subtitle?: string;
  textColor?: ColorProps;
  social?: SocialItemProps[];
  className?: string;
}

function CardPerson({
  img,
  title,
  subtitle,
  textColor = 'white',
  social,
  className
}: Props) {
  return (
    <div
      className={classNames([
        className,
        getColorClass(textColor),
        'relative max-w-md'
      ])}
    >
      <div>
        <Image
          {...img}
          className="mb-5 w-full rounded-xl"
        />
      </div>
      <div>
        <Title
          as="h4"
          size={5}
          weight={900}
          color="inherit"
          className="mb-2"
        >
          {title}
        </Title>
        {subtitle && (
          <Text
            color="inherit"
            leading="tight"
            font="circular"
            as="p"
            size="sm"
            className="mb-5"
          >
            {subtitle}
          </Text>
        )}
        {social && (
          <SocialBar
            socialItems={social}
            iconClassName="text-sl-indigo hover:text-sl-indigo-dark"
          />
        )}
      </div>
    </div>
  );
}

function CardPersonList({ list }: { list: Props[] }) {
  return (
    <div className="flex grid-cols-4 gap-x-5 gap-y-10 overflow-x-scroll pb-3 md:gap-x-7 lg:grid lg:overflow-hidden lg:pb-0">
      {list.map((card) => (
        <CardPerson
          {...card}
          key={list.indexOf(card)}
          className="shrink-0 basis-[calc(100%/1.5-20px)] xsm:basis-[calc(100%/2.2-20px)] sm:basis-[calc(100%/3.2-28px)]"
        />
      ))}
    </div>
  );
}

export default CardPerson;
export { CardPersonList };
